<template>
  <PageContainer id="taralyn-page">
    <div class="page-content">
      <div class="title">We help you stick to it!</div>

      <img :src="taralynImg" alt="A HealthyWager participant">
      <p>“HealthyWage gave me the accountability... <strong>I was able to stick to a diet plan, and actually hit my goal weight,</strong> which I never was able to do until this. And not only that, I've kept it off for nine months.”</p>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="next" :isDisabled="false" :text="'Got it!'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import { STATIC_URL } from '../main';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';
import { navigateTo, ROUTE_NAMES } from '../router';

export default {
  components: {
    PageContainer,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    return {
      taralynImg: `${STATIC_URL}img/spa/taralyn.png`
    }
  },
  methods: {
    next() {
      navigateTo(this.$router, ROUTE_NAMES.PhysicalActivity)
    }
  }
}
</script>
